import { filter } from 'ramda'

import { WarehouseStockExportParams } from 'app/common/types/warehouse/stock'

import type { Request } from '../../../../index'

type ParamsDto = {
  ids?: Array<number>
  school_id?: number
  building_id?: number
  search?: string
}

export const convertParams = ({
  ids,
  orgId,
  buildingId,
  search,
}: WarehouseStockExportParams): [ParamsDto, null] => {
  return [
    filter((val) => val !== undefined, {
      ids: ids?.map((id) => parseInt(id, 10)),
      school_id: orgId ? parseInt(orgId, 10) : undefined,
      building_id: buildingId ? parseInt(buildingId, 10) : undefined,
      search: search || undefined,
    }),
    null,
  ]
}

export const GET_WAREHOUSE_STOCK_EXPORT: Request<WarehouseStockExportParams, unknown, void> = [
  'food/warehouse/stock/export',
  'get',
  ['data'],
]
